import { render } from "./SaveMenuModal.vue?vue&type=template&id=12ecee22"
import script from "./SaveMenuModal.vue?vue&type=script&lang=js"
export * from "./SaveMenuModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__